import React, { useEffect } from 'react';
import LandingNavbar from '../LandingNavbar';
import LandingFooter from '../LandingFooter';
import '../resources/ResourcesLayout.css';

/**
 * CompanyLayout — Shared wrapper for all company pages
 * Reuses the resource layout CSS for consistent look + feel
 */
const CompanyLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rsc-layout">
      <LandingNavbar />
      <main className="rsc-main">
        {children}
      </main>
      <LandingFooter />
    </div>
  );
};

export default CompanyLayout;
